// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Y8Bfd","title":"style_title__ANqcg","description":"style_description__GTWEE","actions":"style_actions__LE5e+","actions_btn":"style_actions_btn__MMZFz"};